import React from 'react';

const DatePreviewer: React.FC = () => {
    return (
        <div className="w-full h-full flex items-center justify-center p-2">
            <div className="text-center w-full" style={{ fontSize: 'clamp(8px, 1.5vw, 14px)' }}>
                {new Date().toLocaleDateString()}
            </div>
        </div>
    );
};

export default DatePreviewer;
